export const SET_VALUE_SHOW_QUESTION = 'SET_VALUE_SHOW_QUESTION';
export const SET_VALUE_QUESTION = 'SET_VALUE_QUESTION';
export const SET_SHOW_GROUP = 'SET_SHOW_GROUP';
export const SET_SHOW_PARTIE = 'SET_SHOW_PARTIE';
export const REMOVE_PARTIE = 'REMOVE_PARTIE';
export const ADD_PARTIE = 'ADD_PARTIE';
export const SET_CODE_FIRST_ERROR = 'SET_CODE_FIRST_ERROR';
export const UPDATE = 'UPDATE';
